export const getUsageTypeString = (type: string) => {
  switch (type) {
    case "충전(정상)":
      return "충전";
    case "충전(반품)":
      return "충전 취소";
    default:
      return "사용";
  }
};

export const getUsageAmount = (type: string, amount?: number) => {
  if (!amount) return 0;

  switch (type) {
    case "사용":
    case "반품":
      return amount * -1;
    default:
      return amount;
  }
};
